import { omit, isNil } from 'lodash';

const getPureChangedItem = <T extends {}>(
  item: T,
  notPureFields: string | string[] = ['error', '_id'],
): Partial<T> => {
  if (isNil(item)) {
    return item;
  }

  return omit(item, notPureFields);
};

export { getPureChangedItem };
